import * as angular from 'angular';
import {IController} from "angular";
import * as _ from "lodash";
import {AccountModel, SchedulingProjectConfigurations} from "../../../account/angular/models/account.model";
import {AccountsService} from "../../../account/services/accounts-service.service";

export class SchedulingProjectConfigurationsComponent implements IController {

  account: AccountModel;

  public isSaveAvailable: boolean;
  public configurations: SchedulingProjectConfigurations;

  constructor(private accountsService: AccountsService) {
  }

  $onInit() {
    this.configurations = angular.copy(this.account.strategicPriority);
  }

  onChangeSchedulingProjectSegment(segment: number) {
    if (!this.configurations) {
      this.configurations = {};
    }

    if (_.isNil(segment)) {
      delete this.configurations.segment;
    } else {
      this.configurations.segment = segment;
    }

    this.onUpdate();
  }

  onUpdate() {
    this.isSaveAvailable = !_.isEqual(this.account.strategicPriority, this.configurations);
  }


  onSave(form) {
    if (form) {
      form.$setSubmitted(true);
      if (form.$valid) {
        this._updateConfigurations();
      }
    }
  }

  onCancelChanges() {
    this.configurations = angular.copy(this.account.strategicPriority);
    this.onUpdate();
  }

  private _updateConfigurations() {
    this.accountsService.setSchedulingProjectConfigurations(
      this.account.id,
      this.configurations
    )
      .then(() => {
          this.account.strategicPriority = this.configurations;
          this.configurations = angular.copy(this.account.strategicPriority);
          this.isSaveAvailable = false;
        }
      )
      .catch(error => {
        this.configurations = angular.copy(this.account.strategicPriority);
        this.isSaveAvailable = false;
      });
  }

}

angular
  .module('bringoz.admin.scheduling-project')
  .component('schedulingProjectConfigurations', {
    bindings: {
      account: '<?'
    },
    template: require('./scheduling-project-configurations.html').default,
    controller: SchedulingProjectConfigurationsComponent
  });
